import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import {
  COLOR_WITHDRAW_STATUS,
  getPlatFormImage,
  LIST_OPTION_BAR_LIST_OPEN_STATUS,
  LIST_WITHDRAW_STATUS_OPTION,
} from "helpers/constans";
import CountUp from "react-countup";
import {
  formatDateStringToKorea,
  formatDateStringToUTC,
  formatNumberWithCommas,
} from "helpers/format";
import TooltipCustom from "components/Common/TooltipCustom";
import CollapseFilter from "components/Common/CollapseFilter";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import CopyWrapper from "components/Common/CopyWrapper";
import DropdownAsyncUsersReferral from "components/Common/DropdownAsyncUsersReferral";
import GroupInfoUser from "components/Common/GroupInfoUser";
import { getRequestWithdraws } from "store/request-withdraw/thunk";
import avatar1 from "../../assets/images/users/ic_defaul_avatar2.png";
import { Link } from "react-router-dom";
import WithdrawDetail from "./WithdrawDetail";
import DropdownAsyncBank from "components/Common/DropdownAsyncBank";

const TYPE_SELECT_DEFAULT: string = "created_at";

registerLocale("en", en);
registerLocale("ko", ko);

const RequestWithdraw = () => {
  const { t, i18n } = useTranslation();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    nickname: withDefault(StringParam, ""),
    email: withDefault(StringParam, ""),
    account_holder_name: withDefault(StringParam, ""),
    account_number: withDefault(StringParam, ""),
    cancel_user_id: withDefault(StringParam, ""),
    bank_id: withDefault(StringParam, ""),
    admin_id: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),
    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [nickNameSearch, setNicknameSearch] = useState<string>(
    query?.nickname || ""
  );
  const [emailSearch, setEmailSearch] = useState<string>(query?.email || "");
  const [accountHolderNameSearch, setAccountHolderNameSearch] =
    useState<string>(query?.account_holder_name || "");
  const [accountNumberSearch, setAccountNumberSearch] = useState<string>(
    query?.account_number || ""
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [bankIDSearch, setBankIDSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [cancelUserSearch, setCancelUserSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [statusSearch, setStatusSearch] = useState<any>(
    LIST_OPTION_BAR_LIST_OPEN_STATUS?.find(
      (item) => item?.value === query?.status
    )?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Withdraw;
  const WithdrawProperties = createSelector(selectLayoutState, (state) => ({
    withdraws: state.withdraws,
    isWithdrawLoading: state.isWithdrawLoading,
    isWithdrawSuccess: state.isWithdrawSuccess,
    error: state.error,
  }));

  // Inside your component
  const { withdraws, isWithdrawLoading } = useSelector(WithdrawProperties);
  const [linkImage, setLinkImage] = useState<string>("");
  const [rewardStatusEdit, setRewardStatusEdit] = useState<any>(null);
  const [rewardNoteEdit, setRewardNoteEdit] = useState<any>(null);
  const [itemToDetail, setItemToDetail] = useState<any>(null);

  function loadTableData() {
    dispatch(getRequestWithdraws(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      nickname: nickNameSearch,
      email: emailSearch,
      account_holder_name: accountHolderNameSearch,
      account_number: accountNumberSearch,
      admin_id:
        cancelUserSearch?.value !== "all" ? cancelUserSearch?.value : "",
      bank_id: bankIDSearch?.value !== "all" ? bankIDSearch?.value : "",
      status: statusSearch,
      start_date: startDate
        ? formatDateStringToUTC(
            moment(new Date(startDate))
              .startOf("day")
              .format("Y-MM-DD HH:mm:ss")
          )
        : "",
      end_date: endDate
        ? formatDateStringToUTC(
            moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        cancel_user_id: "",
        bank_id: "",
        status: "",
        start_date: "",
        end_date: "",
        sort_by: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );
    setNicknameSearch("");
    setEmailSearch("");
    setAccountHolderNameSearch("");
    setAccountNumberSearch("");
    
    setCancelUserSearch({
      label: t("All Filter"),
      value: "all",
    });
    setBankIDSearch({
      label: t("All Filter"),
      value: "all",
    });
    setStatusSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 70,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ minWidth: "60px" }}>
              {withdraws?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index) || 1}
            </div>
          );
        },
      },
      {
        Header: t("Transaction No"),
        accessor: "code",
        filterable: false,
        sortable: false,
        thWidth: 80,
        thClass: "text-left whitespace-nowrap",
        Cell: (cell: any) => {
          const transactionNo = cell?.value;

          return transactionNo ? (
            <CopyWrapper
              contentCopy={transactionNo || ""}
              style={{ display: "inline-flex", minWidth: "20px" }}
            >
              {transactionNo}
            </CopyWrapper>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        filterable: false,
        sortable: false,
        thWidth: 80,
        thClass: "text-left whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const status = cell?.value;
          const msgError = item?.reason_rejected;

          return (
            <div
              className="position-relative d-flex align-items-center gap-1 justify-content-left"
              style={{ minWidth: rewardStatusEdit ? 170 : 110 }}
            >
              <div className="text-center" style={{ lineHeight: "16px" }}>
                <span
                  className={`rounded-pill badge bg-${
                    COLOR_WITHDRAW_STATUS[status] || "secondary"
                  }`}
                >
                  {t(
                    LIST_WITHDRAW_STATUS_OPTION?.find(
                      (item: any) => String(item?.value) === String(status)
                    )?.label ?? ""
                  )}
                </span>
              </div>
              {status === "rejected" && msgError && (
                <TooltipCustom
                  title={t(msgError)}
                  className="d-inline-block vertical-align-middle ms-1 thumbnail-mt"
                  style={{
                    transform: "translateY(2px)",
                    position: "absolute",
                    top: "calc(50% - 9px)",
                    right: 0,
                    paddingLeft: 4,
                    paddingRight: 3,
                    lineHeight: "18px",
                  }}
                >
                  <i
                    className="ri-question-line align-bottom text-secondary"
                    style={{ fontSize: "16px" }}
                  ></i>
                </TooltipCustom>
              )}
            </div>
          );
        },
      },
      {
        Header: t("User Request"),
        accessor: "User Request",
        thClass: "align-middle text-start whitespace-nowrap",
        filterable: false,
        sortable: false,
        thWidth: 600,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.user;

          return <GroupInfoUser item={item} />;
        },
      },
      {
        Header: t("Request Amount"),
        accessor: "amount",
        thClass: "text-end whitespace-nowrap",
        thWidth: 150,
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const platform = getPlatFormImage(item?.currency);
          return (
            <>
              <div
                className="text-end text-nowrap"
                style={{ minWidth: "100px" }}
              >
                <div>
                  {formatNumberWithCommas(cell?.value || 0)}{" "}
                  <img src={platform} width={20} height={20} alt="platform" />
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: t("Total Record"),
        accessor: "total_referral_reward",
        thWidth: 180,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <div className="text-end" style={{ minWidth: 80 }}>
              {cell?.value || "-"}
            </div>
          );
        },
      },
      {
        Header: t("Bank Account"),
        accessor: "bank",
        thWidth: 240,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return cell?.value ? (
            <div style={{ minWidth: 240 }}>
              <p className="m-0">{cell?.value?.bank_name}</p>
              <div className="d-flex gap-1 align-items-center">
                {cell?.value?.bank_account_number}
                <div
                  style={{ width: "1px", height: "10px", background: "gray" }}
                />
                {cell?.value?.bank_account_holder_name}
              </div>
            </div>
          ) : (
            "-"
          );
        },
      },
      // {
      //   Header: t("Bank Transaction No"),
      //   accessor: "bank.bank_transaction_no",
      //   filterable: false,
      //   sortable: false,
      //   thWidth: 80,
      //   thClass: "text-left whitespace-nowrap",
      //   Cell: (cell: any) => {
      //     const transactionNo = cell?.value;

      //     return transactionNo ? (
      //       <CopyWrapper
      //         contentCopy={transactionNo || ""}
      //         style={{ display: "inline-flex", minWidth: "20px" }}
      //       >
      //         {transactionNo}
      //       </CopyWrapper>
      //     ) : (
      //       "-"
      //     );
      //   },
      // },
      // {
      //   Header: t("Bank Name"),
      //   accessor: "bank.bank_name",
      //   thWidth: 180,
      //   thClass: "whitespace-nowrap",
      //   Cell: (cell: any) => {
      //     const bankName = cell?.value;

      //     return bankName ? (
      //       <CopyWrapper
      //         contentCopy={bankName || ""}
      //         style={{
      //           display: "inline-flex",
      //           minWidth: "20px",
      //           textWrap: "nowrap",
      //         }}
      //       >
      //         {bankName}
      //       </CopyWrapper>
      //     ) : (
      //       "-"
      //     );
      //   },
      // },
      // {
      //   Header: t("Account Holder Name"),
      //   accessor: "bank.bank_account_holder_name",
      //   thWidth: 180,
      //   thClass: "text-end whitespace-nowrap",
      //   Cell: (cell: any) => {
      //     const accountName = cell?.value;

      //     return accountName ? (
      //       <CopyWrapper
      //         contentCopy={accountName || ""}
      //         style={{ display: "inline-flex", minWidth: "20px" }}
      //       >
      //         {accountName}
      //       </CopyWrapper>
      //     ) : (
      //       "-"
      //     );
      //   },
      // },
      // {
      //   Header: t("Account Number"),
      //   accessor: "bank.bank_account_number",
      //   thWidth: 180,
      //   thClass: "whitespace-nowrap",
      //   Cell: (cell: any) => {
      //     return cell?.value ? (
      //       <CopyWrapper
      //         contentCopy={cell?.value || ""}
      //         style={{ display: "inline-flex", minWidth: "20px" }}
      //       >
      //         {cell?.value}
      //       </CopyWrapper>
      //     ) : (
      //       "-"
      //     );
      //   },
      // },
      {
        Header: t("Processed by"),
        accessor: "process_by",
        filterable: true,
        thClass: "whitespace-nowrap",
        sortable: false,
        Cell: (cell: any) => {
          const item = cell?.value;

          return (
            item && (
              <div
                className="d-flex align-items-center gap-2"
                style={{ minWidth: "175px" }}
                key={item?.id}
              >
                {/* <div
                  style={{
                    height: "35px",
                    width: "35px",
                    overflow: "hidden",
                    borderRadius: "15px",
                    objectFit: "cover",
                    backgroundColor: "#eaeaea",
                    minWidth: "25px",
                  }}
                >
                  <img
                    src={item?.userProfile?.profile_image_url || avatar1}
                    alt={item?.userProfile?.nickname}
                    height={35}
                    width={35}
                    className="me-2"
                    style={{
                      overflow: "hidden",
                      borderRadius: "50%",
                      objectFit: "cover",
                      backgroundColor: "#eaeaea",
                    }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = avatar1;
                    }}
                  />
                </div> */}
                <div>
                  {`${item?.first_name || ""} ${item?.last_name || ""}`} <br />
                  {item?.email || ""}
                </div>
              </div>
            )
          );
        },
      },
      {
        Header: t("Requested at"),
        accessor: "requested_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Completed at"),
        accessor: "completed_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "align-middle text-center",
        thWidth: 120,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0 "
              style={{ justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("View Detail")}
                id={`view-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDetail(item);
                  }}
                >
                  <i className="ri-eye-fill align-bottom "></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      i18n?.language,
      withdraws?.pagination?.total,
      query?.page,
      rewardStatusEdit,
      rewardNoteEdit,
    ]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const onCloseClick = () => {
    setItemToDetail(null);
  };
  const triggerRefresh = () => {
    onCloseClick();
    dispatch(getRequestWithdraws(query));
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Request Withdraw")} - ${t("Home")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Request Withdraw")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={withdraws?.pagination?.total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Requested")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={withdraws?.summary?.requested || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Processing")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={withdraws?.summary?.processing || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Completed")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={withdraws?.summary?.completed || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Rejected")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={withdraws?.summary?.rejected || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Needs Correction")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      withdraws?.summary?.needs_correction || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total User Cancelled")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={withdraws?.summary?.cancelled || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </CardHeader>

                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Nickname")}
                          isShow={!!nickNameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Nickname")}...`}
                            value={nickNameSearch}
                            onChange={(e) => setNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Email")} isShow={!!emailSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email")}...`}
                            value={emailSearch}
                            onChange={(e) => setEmailSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Account Holder Name")}
                          isShow={!!accountHolderNameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Account Holder Name")}...`}
                            value={accountHolderNameSearch}
                            onChange={(e) =>
                              setAccountHolderNameSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Account Number")}
                          isShow={!!accountNumberSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Account Number")}...`}
                            value={accountNumberSearch}
                            onChange={(e) =>
                              setAccountNumberSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-3"
                      >
                        <LabelWrapper label={t("Bank Name")} isShow={true}>
                          <DropdownAsyncBank
                            name="referral-user"
                            onChangeSelect={(event: any) => {
                              setBankIDSearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select bank")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={bankIDSearch}
                            paramsTypeUsers={"referral"}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-3"
                      >
                        <LabelWrapper label={t("Processed by")} isShow={true}>
                          <DropdownAsyncUsersReferral
                            name="receive-user"
                            onChangeSelect={(event: any) => {
                              setCancelUserSearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select user")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={cancelUserSearch}
                            paramsTypeUsers={"receiver"}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_WITHDRAW_STATUS_OPTION || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_WITHDRAW_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={12}
                        xl={12}
                        xxl={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={withdraws?.items?.length ? withdraws?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={withdraws?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(withdraws?.pagination?.total) /
                          Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isWithdrawLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {itemToDetail && (
          <WithdrawDetail
            id={String(itemToDetail?.id || "")}
            item={itemToDetail}
            triggerRefresh={triggerRefresh}
            onCloseClick={onCloseClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default RequestWithdraw;
